import { isChoiceEligible } from '../../choiceExpansion';

const isRecentlyViewedAsChoiceGig = ({ gig, algorithmType, algoTypes, recentlyViewedChoiceGigs, abTests }) => {
    const { gig_id: gigId, choice_eligibilities: choiceEligibilities } = gig;
    const inAlgoTypes = algoTypes.includes(algorithmType);
    const inRecentlyViewedGigs = recentlyViewedChoiceGigs.includes(gigId);

    return inAlgoTypes && inRecentlyViewedGigs && isChoiceEligible(abTests, choiceEligibilities);
};

export const markGigsAsChoice = ({
    gigs,
    gigsProperties,
    abTests = {},
    recentlyViewedChoiceGigs = [],
    algoTypes = {},
}) => {
    let hasChoiceEnrichment = false;

    if (!recentlyViewedChoiceGigs) {
        return { enrichedGigs: gigs, hasChoiceEnrichment };
    }

    return {
        enrichedGigs: gigs.map((gig, index) => {
            const { algorithm_type: algorithmType } = gigsProperties[index];
            const isRecentlyViewedAsFiverrChoiceGig = isRecentlyViewedAsChoiceGig({
                gig,
                algorithmType,
                algoTypes,
                recentlyViewedChoiceGigs,
                abTests,
            });

            hasChoiceEnrichment = hasChoiceEnrichment || isRecentlyViewedAsFiverrChoiceGig;

            return isRecentlyViewedAsFiverrChoiceGig ? { ...gig, is_fiverr_choice: true } : gig;
        }),
        hasChoiceEnrichment,
    };
};
